import { useEffect, useState } from 'react';

import { Shell } from '../componentes/Shell.jsx';

/**
 * Estado de conexión (RF-023, RN-025, RNF-020, D-02).
 *
 * Sin captura offline: guardar exige conexión y confirmación del servidor. El
 * shell abre desde caché con su barra completa, las pantallas de datos muestran
 * estado vacío explicativo y los botones de guardar quedan deshabilitados. No se
 * guarda nada localmente ni se promete guardar después.
 */
export default function SinConexion() {
  const [enLinea, setEnLinea] = useState(() => (typeof navigator === 'undefined' ? true : navigator.onLine !== false));

  useEffect(() => {
    const conectar = () => setEnLinea(true);
    const desconectar = () => setEnLinea(false);
    window.addEventListener('online', conectar);
    window.addEventListener('offline', desconectar);
    return () => {
      window.removeEventListener('online', conectar);
      window.removeEventListener('offline', desconectar);
    };
  }, []);

  return (
    <Shell titulo="Estado de conexión" volverA="/ajustes">
      <div className={`aviso ${enLinea ? 'n' : 'w'}`}>
        {enLinea
          ? '✔ En línea. Puedes guardar con normalidad.'
          : '▲ Sin conexión. Necesitas conexión para guardar; lo capturado se conserva en el formulario para reintentar.'}
      </div>

      <div className="card">
        <h3>Cómo se comporta la aplicación sin red</h3>
        {/* Filas 11 y 12 del inventario del incremento 15 (RF-222/RF-223): salió la jerga
            técnica («armazón», «caché», «cola de sincronización», «escritura local
            diferida») y las dos últimas viñetas, que decían lo mismo, quedaron en una. */}
        <ul style={{ paddingLeft: 18, margin: '6px 0' }} data-prueba="sin-conexion-lista">
          <li>La aplicación abre y puedes moverte por todas sus secciones.</li>
          <li>Las pantallas de datos muestran un estado vacío explicativo.</li>
          <li>Los botones de guardar quedan deshabilitados con el mensaje correspondiente.</li>
          <li>Nada se guarda “para después”: lo que no alcanzó a guardarse con conexión, no se guardó.</li>
        </ul>
      </div>

      {/* Fila 13 del inventario del incremento 15 (RF-222/RF-223, D-325): se retiró el
          recuadro que explicaba el guardado por dentro; lo útil ya queda dicho en las
          viñetas de arriba. La pantalla no gana acciones: no hay botón «Reintentar»
          (D-329) y el único control sigue siendo el volver del encabezado. */}
    </Shell>
  );
}
